import { useState } from 'react'

export function InstagramCarousel() {
  const [currentPanel, setCurrentPanel] = useState(0)
  
  const panels = [
    {
      id: 'hero',
      background: 'bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400',
      content: (
        <div className="flex flex-col items-center justify-center h-full text-white text-center px-20 py-20">
          <div className="w-48 h-48 bg-white/20 backdrop-blur-lg rounded-3xl flex items-center justify-center mb-16 shadow-2xl">
            <span className="text-8xl">📢</span>
          </div>
          <h1 className="text-9xl font-black mb-10 tracking-tight">ŠIRIMO SE</h1>
          <div className="h-2 w-40 bg-white/40 rounded-full mb-10"></div>
          <p className="text-4xl font-light opacity-90 leading-relaxed mb-10">
            Sistem za koordinaciju<br/>građanskih akcija
          </p>
          <div className="bg-white/20 backdrop-blur-lg rounded-3xl px-10 py-6 mt-8">
            <p className="text-3xl font-medium">
              Zajedno smo jači - pametniji se organizuje!
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'features',
      background: 'bg-white',
      content: (
        <div className="flex flex-col h-full px-20 py-16">
          <div className="mb-12">
            <h2 className="text-7xl font-black text-gray-900 mb-4">Šta je to?</h2>
            <div className="h-2 w-32 bg-blue-500 rounded-full mb-8"></div>
            <p className="text-3xl text-gray-600 leading-relaxed">
              Sistem za <strong>live koordinaciju građanskih akcija</strong> i pravovremene zaštite građana preko X (Twitter) platforme
            </p>
          </div>
          <div className="space-y-16 flex-1 flex flex-col justify-center">
            {[
              { icon: '🚧', text: 'Oglasite ili saznajte o', highlight: 'novim aktivnim blokadama', rest: 'u svom kraju' },
              { icon: '⚠️', text: 'Prijavite ili saznajte o', highlight: 'ugrožavanju bezbednosti gradjana', rest: 'kako bi ih zaštitili' },
              { icon: '📍', text: 'Oglasite ili saznajte', highlight: 'o zborovima', rest: 'u svojoj okolini i pridružite se borbi' },
              { icon: '⚖️', text: '', highlight: 'Saznajte o svojim pravima', rest: 'u kontaktu sa državnim organima' }
            ].map((item, i) => (
              <div key={i} className="flex items-start group">
                <div className="text-7xl mr-12 mt-1 transform group-hover:scale-110 transition-transform flex-shrink-0">{item.icon}</div>
                <p className="text-4xl text-gray-700 leading-relaxed">
                  {item.text} <span className="font-bold text-gray-900 bg-yellow-100 px-4 py-2 rounded-lg">{item.highlight}</span> {item.rest}
                </p>
              </div>
            ))}
          </div>
        </div>
      )
    },
    {
      id: 'how-it-works-visual',
      background: 'bg-gradient-to-br from-gray-50 to-gray-100',
      content: (
        <div className="flex flex-col h-full px-20 py-16">
          <div className="mb-12">
            <h2 className="text-7xl font-black text-gray-900 mb-4">Kako funkcioniše?</h2>
            <div className="h-2 w-32 bg-blue-500 rounded-full"></div>
          </div>
          
          <div className="flex-1 flex flex-col justify-center">
            {/* Visual flow diagram */}
            <div className="space-y-10">
              {/* Step 1 */}
              <div className="flex items-center">
                <div className="flex-shrink-0 w-24 h-24 bg-blue-500 rounded-full flex items-center justify-center text-white text-4xl font-bold">
                  1
                </div>
                <div className="ml-10 flex-1">
                  <div className="flex items-center gap-6">
                    <img src="/twitter-3-logo-png-transparent.png" alt="X/Twitter" className="w-20 h-20 object-contain" />
                    <div>
                      <p className="text-3xl font-bold text-gray-800">Objavite na X (Twitter)</p>
                      <p className="text-2xl text-gray-600">sa #sirimose i drugim hashtag-ovima</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Arrow */}
              <div className="flex justify-center py-4">
                <div className="text-6xl text-blue-400">↓</div>
              </div>
              
              {/* Step 2 */}
              <div className="flex items-center">
                <div className="flex-shrink-0 w-24 h-24 bg-blue-500 rounded-full flex items-center justify-center text-white text-4xl font-bold">
                  2
                </div>
                <div className="ml-10 flex-1">
                  <div className="flex items-center gap-6">
                    <span className="text-6xl">⏱️</span>
                    <div>
                      <p className="text-3xl font-bold text-gray-800">Za samo 5 minuta</p>
                      <p className="text-2xl text-gray-600">vaša objava se pojavljuje na monitoru</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Arrow */}
              <div className="flex justify-center py-4">
                <div className="text-6xl text-blue-400">↓</div>
              </div>
              
              {/* Step 3 */}
              <div className="flex items-center">
                <div className="flex-shrink-0 w-24 h-24 bg-blue-500 rounded-full flex items-center justify-center text-white text-4xl font-bold">
                  3
                </div>
                <div className="ml-10 flex-1">
                  <div className="flex items-center gap-6">
                    <img src="/icon1.png" alt="Širimo Se" className="w-20 h-20 object-contain" />
                    <div>
                      <p className="text-3xl font-bold text-gray-800">Građani vide i reaguju</p>
                      <p className="text-2xl text-gray-600">brza koordinacija i pomoć</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-12 bg-blue-50 rounded-3xl p-8 border-2 border-blue-200">
              <p className="text-2xl text-blue-800 text-center">
                <strong>Automatski sistem:</strong> Zadržavamo tvitove sa 5+ lajkova u prvih 15 min ili 20+ lajkova u prvom satu
              </p>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'hashtags-detailed',
      background: 'bg-white',
      content: (
        <div className="flex flex-col h-full px-20 py-16">
          <div className="mb-12">
            <h2 className="text-7xl font-black text-gray-900 mb-4">Kako koristiti hashtag-ove?</h2>
            <div className="h-2 w-32 bg-blue-500 rounded-full"></div>
          </div>
          
          <div className="bg-green-50 border-2 border-green-300 rounded-3xl p-8 mb-10">
            <p className="text-3xl text-green-800 font-medium text-center">
              Obavezno: <span className="bg-green-200 px-6 py-3 rounded-xl font-mono font-bold">#sirimose</span>
            </p>
          </div>
          
          <div className="flex-1 space-y-12">
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
                <span className="text-4xl mr-4">📍</span> Lokacija
              </h3>
              <div className="bg-gray-50 rounded-2xl p-8">
                <div className="flex flex-wrap gap-4 mb-6">
                  {['#beograd', '#novisad', '#valjevo', '#zemun', '#gazela', '#brankovmost', '#ustanicka'].map(tag => (
                    <span key={tag} className="bg-gray-200 text-gray-700 px-8 py-4 rounded-full text-2xl font-medium">
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="text-xl text-gray-600 italic">
                  💡 Savet: U većem gradu stavite i ime grada i specifičnu lokaciju
                </p>
              </div>
            </div>
            
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
                <span className="text-4xl mr-4">🎯</span> Tematika
              </h3>
              <div className="bg-gray-50 rounded-2xl p-8">
                <div className="flex flex-wrap gap-4 mb-6">
                  {['#novablokada', '#dodjite', '#uzbuna', '#hapsenje', '#zandarmerija', '#nasilje', '#probijanje'].map(tag => (
                    <span key={tag} className="bg-gray-200 text-gray-700 px-8 py-4 rounded-full text-2xl font-medium">
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="text-xl text-gray-600 italic">
                  💡 Za nove blokade: #novablokada, za pretnje: #uzbuna + vrsta pretnje
                </p>
              </div>
            </div>
            
            <div className="bg-yellow-50 border-2 border-yellow-300 rounded-2xl p-8">
              <p className="text-2xl text-yellow-800 flex items-start">
                <span className="text-3xl mr-4">📸</span>
                <span><strong>Važno:</strong> Dodajte foto/video za dokumentovanje i lakšu verifikaciju!</span>
              </p>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'real-examples',
      background: 'bg-gradient-to-br from-gray-50 to-gray-100',
      content: (
        <div className="flex flex-col h-full px-20 py-16">
          <div className="mb-12">
            <h2 className="text-7xl font-black text-gray-900 mb-4">Stvarni primeri</h2>
            <div className="h-2 w-32 bg-blue-500 rounded-full"></div>
          </div>
          
          <div className="flex-1 flex flex-col justify-center space-y-12">
            {/* Tweet example */}
            <div className="bg-white rounded-3xl shadow-lg p-10">
              <div className="flex items-start mb-6">
                <img 
                  src="/icon.png" 
                  alt="Profile" 
                  className="w-16 h-16 rounded-full mr-6"
                />
                <div className="flex-1">
                  <h3 className="text-3xl font-bold text-gray-800 mb-1">Blokada Vojislava Ilica i Ustanicke</h3>
                  <p className="text-2xl text-gray-500">@blokadaustanicka</p>
                </div>
              </div>
              <p className="text-2xl text-gray-800 mb-6">
                "Počinjemo blokadu na Ustanička! Dođite što pre! #sirimose #beograd #ustanicka #novablokada #dodjite"
              </p>
              <div className="flex flex-wrap gap-3">
                <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-xl">#sirimose</span>
                <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-xl">#uzbuna</span>
                <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-xl">#dodjite</span>
                <span className="bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-xl">#beograd</span>
              </div>
            </div>
            
            {/* Monitor screenshot showcase */}
            <div className="bg-white rounded-3xl shadow-lg overflow-hidden">
              <div className="p-8">
                <h3 className="text-3xl font-bold text-gray-800 mb-4">Kako izgleda na našem monitoru</h3>
                <p className="text-2xl text-gray-600 mb-6">
                  Sve objave sa #sirimose se prikazuju u realnom vremenu
                </p>
              </div>
              <div className="bg-gray-100 p-6">
                <img 
                  src="/primer-monitor-blokada-u-mom-gradu.jpeg" 
                  alt="Monitor sistema" 
                  className="w-full rounded-2xl shadow-lg"
                  style={{ maxHeight: '300px', objectFit: 'cover', objectPosition: 'top' }}
                />
              </div>
              <div className="bg-blue-50 p-6 text-center">
                <p className="text-xl text-blue-800">
                  <strong>Ažuriranje svakih 5 minuta</strong> • <strong>Tvitovi do 36 sati</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'cta-detailed',
      background: 'bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400',
      content: (
        <div className="flex flex-col items-center justify-center h-full text-white text-center px-20 py-20">
          <h2 className="text-8xl font-black mb-12">PRIDRUŽITE SE!</h2>
          
          <div className="space-y-8 mb-16">
            <p className="text-5xl font-light opacity-95">Zajedno smo jači!</p>
            <p className="text-5xl font-light opacity-95">Pametniji se organizuje!</p>
          </div>
          
          <div className="bg-white/20 backdrop-blur-lg rounded-3xl p-12 mb-16">
            <p className="text-3xl mb-8 opacity-90">Posetite naš monitor:</p>
            <div className="bg-white text-blue-600 px-20 py-10 rounded-3xl text-6xl font-bold shadow-2xl">
              sirimo.se
            </div>
          </div>
          
          <div className="space-y-6 text-2xl opacity-90">
            <p>📊 Ažuriranje na svakih 5 minuta</p>
            <p>⏰ Tvitovi ne stariji od 36 sati</p>
            <p>🔍 Pretraživanje po hashtag-ovima</p>
            <p>📍 Mapa sa lokacijama</p>
          </div>
          
          <div className="mt-14 bg-white/10 backdrop-blur rounded-2xl px-12 py-6">
            <p className="text-xl opacity-80">
              Ideje ili predlozi: rajko@danposle.org
            </p>
          </div>
        </div>
      )
    }
  ]

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-8">
      <div className="w-full max-w-7xl">
        {/* Panel Navigation */}
        <div className="flex justify-center gap-4 mb-8">
          {panels.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPanel(index)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
                currentPanel === index 
                  ? 'bg-blue-500 text-white shadow-lg' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Panel {index + 1}
            </button>
          ))}
        </div>

        {/* Instagram Frame */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden mx-auto" style={{ width: '1080px', height: '1350px' }}>
          <div className={`w-full h-full relative ${panels[currentPanel].background}`}>
            {panels[currentPanel].content}
            
            {/* Panel indicator */}
            <div className="absolute top-12 right-12 text-white/60 text-2xl font-medium">
              {currentPanel + 1} / {panels.length}
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="mt-8 text-center text-gray-600">
          <p className="mb-2">Kliknite na dugmiće iznad da vidite različite panele</p>
          <p className="text-sm">Koristite screenshot alat vašeg sistema za snimanje svakog panela</p>
        </div>
      </div>
    </div>
  )
} 